import React, { memo } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function CallToAction() {
  return <section id="cta" className="py-20 bg-stone-900 text-stone-100" data-id="element-67">
      <div className="max-w-6xl mx-auto px-6 text-center" data-id="element-68">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-amber-200" data-id="element-69">
          Continue the Journey
        </h2>
        <p className="text-xl mb-10 text-stone-300 max-w-2xl mx-auto" data-id="element-70">
          This is just the beginning of the story. Discover the full journey of
          Charlie Kirk and the movement he inspired in this compelling
          narrative.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-71">
          {/* Digital Copy */}
          <div className="bg-stone-800 p-6 rounded-lg shadow-xl flex flex-col h-full" data-id="element-72">
            <div className="mb-4" data-id="element-73">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uu9QaYSbPYWHCwqD5VMHMF/Generated_Image_October_13%2C_2025_-_3_48PM.png" alt="Digital copy of Voices of Freedom on laptop and tablet" className="w-full aspect-square object-cover object-center rounded-md shadow-lg" data-id="element-74" />
            </div>
            <div className="text-left flex-grow" data-id="element-75">
              <h3 className="text-xl font-bold mb-2 text-amber-300" data-id="element-76">
                Digital Copy
              </h3>
              <div className="flex items-end gap-2 mb-4" data-id="element-77">
                <span className="text-stone-400 line-through text-sm" data-id="element-78">
                  $47.97
                </span>
                <span className="text-2xl font-bold text-amber-200" data-id="element-79">
                  $29.97
                </span>
              </div>
              <ul className="space-y-2 mb-6" data-id="element-80">
                <li className="flex items-center gap-2" data-id="element-81">
                  <span className="text-amber-500" data-id="element-82">✓</span>
                  <span data-id="element-83">Instant Download</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-84">
                  <span className="text-amber-500" data-id="element-85">✓</span>
                  <span data-id="element-86">Includes 1 FREE Bonus!</span>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45180367372474:1" target="_blank" rel="noopener noreferrer" className="bg-amber-600 hover:bg-amber-500 text-white px-4 py-3 rounded-md font-medium transition duration-300 flex items-center justify-center gap-2 w-full mt-4" data-id="element-87">
              Get Digital Copy
              <ArrowRightIcon size={16} data-id="element-88" />
            </a>
          </div>
          {/* Paperback */}
          <div className="bg-stone-800 p-6 rounded-lg shadow-xl flex flex-col h-full" data-id="element-89">
            <div className="mb-4" data-id="element-90">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jEfvnH6vdYhpFCRFZhGj4e/Generated_Image_October_13%2C_2025_-_3_45PM.png" alt="Physical paperback copy of Voices of Freedom" className="w-full aspect-square object-cover object-center rounded-md shadow-lg" data-id="element-91" />
            </div>
            <div className="text-left flex-grow" data-id="element-92">
              <h3 className="text-xl font-bold mb-2 text-amber-300" data-id="element-93">
                Paperback
              </h3>
              <div className="flex items-end gap-2 mb-4" data-id="element-94">
                <span className="text-stone-400 line-through text-sm" data-id="element-95">
                  $67.97
                </span>
                <span className="text-2xl font-bold text-amber-200" data-id="element-96">
                  $49.97
                </span>
              </div>
              <ul className="space-y-2 mb-6" data-id="element-97">
                <li className="flex items-center gap-2" data-id="element-98">
                  <span className="text-amber-500" data-id="element-99">✓</span>
                  <span data-id="element-100">Ships in 14 days</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-101">
                  <span className="text-amber-500" data-id="element-102">✓</span>
                  <span data-id="element-103">Includes 3 FREE Bonuses!</span>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45164055134394:1" target="_blank" rel="noopener noreferrer" className="bg-amber-600 hover:bg-amber-500 text-white px-4 py-3 rounded-md font-medium transition duration-300 flex items-center justify-center gap-2 w-full mt-4" data-id="element-104">
              Order Physical Copy
              <ArrowRightIcon size={16} data-id="element-105" />
            </a>
          </div>
          {/* Premium */}
          <div className="bg-stone-800 p-6 rounded-lg shadow-xl border-2 border-amber-500 flex flex-col h-full relative" data-id="element-106">
            <div className="absolute -top-3 -right-3 bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded" data-id="element-107">
              40% OFF
            </div>
            <div className="mb-4" data-id="element-108">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/11sTfZy2x4JYwAqRtb5yfz/Generated_Image_October_13%2C_2025_-_3_27PM_%282%29.png" alt="Premium edition of Voices of Freedom book" className="w-full aspect-square object-cover object-center rounded-md shadow-lg" data-id="element-109" />
            </div>
            <div className="text-left flex-grow" data-id="element-110">
              <h3 className="text-xl font-bold mb-2 text-amber-300" data-id="element-111">Premium</h3>
              <div className="flex items-end gap-2 mb-4" data-id="element-112">
                <span className="text-stone-400 line-through text-sm" data-id="element-113">
                  $127.97
                </span>
                <span className="text-2xl font-bold text-amber-200" data-id="element-114">
                  $94.97
                </span>
              </div>
              <ul className="space-y-2 mb-6" data-id="element-115">
                <li className="flex items-center gap-2" data-id="element-116">
                  <span className="text-amber-500" data-id="element-117">✓</span>
                  <span data-id="element-118">Ships in 14 days</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-119">
                  <span className="text-amber-500" data-id="element-120">✓</span>
                  <span data-id="element-121">Includes 3 FREE Bonuses!</span>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45164053987514:1" target="_blank" rel="noopener noreferrer" className="bg-amber-600 hover:bg-amber-500 text-white px-4 py-3 rounded-md font-medium transition duration-300 flex items-center justify-center gap-2 w-full mt-4" data-id="element-122">
              Order Premium
              <ArrowRightIcon size={16} data-id="element-123" />
            </a>
          </div>
          {/* Collector's Super Bundle */}
          <div className="bg-stone-800 p-6 rounded-lg shadow-xl border-2 border-amber-300 flex flex-col h-full relative" data-id="element-124">
            <div className="absolute -top-3 -right-3 bg-amber-300 text-stone-900 text-xs font-bold px-3 py-1 rounded" data-id="element-125">
              COLLECTOR'S
            </div>
            <div className="mb-4" data-id="element-126">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rqc9wP7ENyMsr3DW3f7KuK/Generated_Image_October_13%2C_2025_-_5_15PM.png" alt="Collector's Super Bundle with book, signed photo, t-shirt, hat and mug" className="w-full aspect-square object-cover object-center rounded-md shadow-lg" data-id="element-127" />
            </div>
            <div className="text-left flex-grow" data-id="element-128">
              <h3 className="text-xl font-bold mb-2 text-amber-300" data-id="element-129">
                Super Bundle
              </h3>
              <div className="flex items-end gap-2 mb-4" data-id="element-130">
                <span className="text-stone-400 line-through text-sm" data-id="element-131">
                  $419.97
                </span>
                <span className="text-2xl font-bold text-amber-200" data-id="element-132">
                  $251.37
                </span>
              </div>
              <ul className="space-y-2 mb-6" data-id="element-133">
                <li className="flex items-center gap-2" data-id="element-134">
                  <span className="text-amber-500" data-id="element-135">✓</span>
                  <span data-id="element-136">Priority Shipping</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-137">
                  <span className="text-amber-500" data-id="element-138">✓</span>
                  <span data-id="element-139">Includes 3 FREE Bonuses!</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-140">
                  <span className="text-amber-500" data-id="element-141">✓</span>
                  <span className="text-sm" data-id="element-142">5-Item Collection:</span>
                </li>
                <li className="flex items-start gap-2 pl-6" data-id="element-143">
                  <ul className="space-y-1 text-sm" data-id="element-144">
                    <li data-id="element-145">• Limited Edition Art</li>
                    <li data-id="element-146">• Premium Hardcover</li>
                    <li data-id="element-147">• FREEDOM™ Mug</li>
                    <li data-id="element-148">• Signature T-Shirt</li>
                    <li data-id="element-149">• Signature Hat</li>
                  </ul>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45191348289722:1" target="_blank" rel="noopener noreferrer" className="bg-amber-600 hover:bg-amber-500 text-white px-4 py-3 rounded-md font-medium transition duration-300 flex items-center justify-center gap-2 w-full mt-4" data-id="element-150">
              Get Collector's
              <ArrowRightIcon size={16} data-id="element-151" />
            </a>
          </div>
        </div>
        {/* Bonus Details Section */}
        <div className="max-w-4xl mx-auto mb-12 bg-stone-800 rounded-lg p-8 border border-amber-600/30" data-id="element-152">
          <h3 className="text-2xl font-bold mb-6 text-amber-300" data-id="element-153">
            Exclusive Bonuses
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left" data-id="element-154">
            {/* Bonus 1 */}
            <div className="bg-stone-900/50 p-6 rounded-lg border border-amber-600/20" data-id="element-155">
              <div className="flex justify-between items-start mb-3" data-id="element-156">
                <h4 className="text-xl font-bold text-amber-200" data-id="element-157">
                  Bonus 1: Remembering Charlie Kirk
                </h4>
                <span className="bg-amber-600/20 text-amber-300 text-sm font-bold px-3 py-1 rounded" data-id="element-158">
                  $47.97 Value
                </span>
              </div>
              <p className="text-stone-300 leading-relaxed" data-id="element-159">
                A powerful tribute capturing Charlie Kirk's legacy through
                intimate stories, reflections, and timeless lessons. A living
                memorial that inspires future generations to carry the torch of
                freedom.
              </p>
            </div>
            {/* Bonus 2 */}
            <div className="bg-stone-900/50 p-6 rounded-lg border border-amber-600/20" data-id="element-160">
              <div className="flex justify-between items-start mb-3" data-id="element-161">
                <h4 className="text-xl font-bold text-amber-200" data-id="element-162">
                  Bonus 2: The Last Patriot
                </h4>
                <span className="bg-amber-600/20 text-amber-300 text-sm font-bold px-3 py-1 rounded" data-id="element-163">
                  $47.97 Value
                </span>
              </div>
              <p className="text-stone-300 leading-relaxed" data-id="element-164">
                An explosive insider chronicle of the Trump–Kirk alliance that
                sparked a movement. A bold, unapologetic manifesto for the next
                chapter of American patriotism.
              </p>
            </div>
          </div>
          <div className="mt-6 text-center" data-id="element-165">
            <p className="text-amber-300 font-medium" data-id="element-166">
              Total Bonus Value: $95.94 — Included FREE with your purchase!
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-167">
          <div className="flex items-center gap-2 justify-center" data-id="element-168">
            <span className="text-amber-500" data-id="element-169">★★★★★</span>
            <span className="text-stone-400" data-id="element-170">4.9/5 from 10,000+ readers</span>
          </div>
          <div className="text-stone-400" data-id="element-171">30-day money-back guarantee</div>
        </div>
      </div>
    </section>;
}